import { render } from "./PokemonSkeleton.vue?vue&type=template&id=9b08614e&scoped=true"
const script = {}

import "./PokemonSkeleton.vue?vue&type=style&index=0&id=9b08614e&scoped=true&lang=css"

import exportComponent from "/home/trimogesimo/a-subir/Pokemon_Game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b08614e"]])

export default __exports__